import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AttachmentsTable } from './AttachmentsTable';
import { buildingAttachmentsKeys } from './hooks/queryKeys';
const BUILDING_ID = 42;
const sampleRows = [
    {
        id: 1,
        name: '2026-alarm-inspection-report.pdf',
        attachmentCategoryId: 1,
        categoryName: 'Reports',
        createdAt: '2026-09-15T14:30:00-04:00',
        fileSize: 655360,
        isPrivate: false,
        showOnCustomerPortal: true,
        url: 'https://cdn.example.com/reports/2026-alarm-inspection-report.pdf'
    },
    {
        id: 2,
        name: 'panel-photo.jpg',
        attachmentCategoryId: 2,
        categoryName: 'Photos',
        createdAt: '2026-09-20T09:05:00-04:00',
        fileSize: 51200,
        isPrivate: false,
        showOnCustomerPortal: false,
        url: 'https://cdn.example.com/photos/panel-photo.jpg'
    },
    {
        id: 3,
        name: 'floor-plan.dwg',
        attachmentCategoryId: null,
        categoryName: null,
        createdAt: '2026-08-01T11:00:00-04:00',
        fileSize: 3145728,
        isPrivate: true,
        showOnCustomerPortal: false,
        url: 'https://cdn.example.com/plans/floor-plan.dwg'
    },
    {
        id: 4,
        name: 'walkthrough.mp4',
        attachmentCategoryId: 3,
        categoryName: 'Permits',
        createdAt: '2026-09-25T16:45:00-04:00',
        fileSize: 25794969,
        isPrivate: true,
        showOnCustomerPortal: true,
        url: 'https://cdn.example.com/videos/walkthrough.mp4'
    },
    {
        id: 5,
        name: 'invoice-summary.xlsx',
        attachmentCategoryId: 1,
        categoryName: 'Reports',
        createdAt: '2026-09-10T08:00:00-04:00',
        fileSize: 20480,
        isPrivate: false,
        showOnCustomerPortal: false,
        url: 'https://cdn.example.com/misc/invoice-summary.xlsx'
    }
];
function withSeededQuery(rows) {
    return function Story() {
        const client = useMemo(() => {
            const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false } } });
            queryClient.setQueryData(buildingAttachmentsKeys.list(BUILDING_ID), rows);
            return queryClient;
        }, []);
        return (React.createElement(QueryClientProvider, { client: client },
            React.createElement(AttachmentsTable, { buildingId: BUILDING_ID })));
    };
}
const meta = {
    title: 'Features/BuildingAttachments/AttachmentsTable',
    tags: ['autodocs'],
    parameters: { layout: 'padded' }
};
export default meta;
/** Mixed file types, categories, and visibility combinations. */
export const Populated = { render: withSeededQuery(sampleRows) };
/** E2E-04: zero attachments — the section-header CTA is hidden, the empty block carries its own. */
export const Empty = { render: withSeededQuery([]) };
